import { withInstall } from '@ll-plus/utils'

import DescriptionsItem from './src/descriptions-item.vue'

export const LlDescriptionsItem = withInstall(DescriptionsItem)
export default LlDescriptionsItem
export * from './src/descriptions-item'

declare module 'vue' {
  export interface GlobalComponents {
    LlDescriptionsItem: typeof DescriptionsItem
  }
}
